<template>
	<div class="newdetail">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item :to="{ path: '/NewCenter' }">新闻中心</el-breadcrumb-item>
				  	<p style="overflow:hidden;width:30%;white-space:nowrap;text-overflow:ellipsis;">{{data.title}}</p>
				  	<!-- <el-breadcrumb-item style="overflow:hidden;white-space:">{{data.title}}</el-breadcrumb-item> -->
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content clearfix">
				<div class="content-title clearfix">
					<h1>{{data.title}}</h1>
					<p class="clearfix">
						<span class="time">{{data.addtime}}</span>
						<span class="view">浏览量：{{data.clickNum}}</span>
					</p>
					
				</div>
				
				<div class="content-lists" style="font-size:14px;" v-html="data.content"></div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				data:'',
				banner:''
			}
		},
		methods:{
			getDetail(){
				var id = this.$route.query.id;
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsDetailApi+id,
					data: {}
				})
				.then((res) => {
					this.data = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'3',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner3;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getDetail();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.newdetail{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			i{
				.font-size(20);
			}
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(70);
			.margin-bottom(70);
			.content-title{
				width: 100%;
				border-bottom:1px solid #eee;
				.padding-bottom(20);
				h1{
					.font-size(35);
					font-weight:600;
					text-align: center;
					.margin-bottom(20);
					i{
						color: #00A0FF;
						.margin-right(30);
					}
				}
				p{
					span{
						color:#696969;
						.font-size(24);
					}
					.view{
						float: right;
					}
					.time{
						float: left;
					}
				}

			}
			.content-lists{
				overflow:hidden;
				width:100%;
				.margin-top(20);
				p{
					.font-size(14) !important;
				}
			}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/NewDetail.vue